import validateCategoryParameters from './validateCategoryParameters';
import updateConversationsCategoriesService from '../../../services/updateConversationsCategoriesService';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import conversationsCategoriesStoreUpdate from 'owa-mail-actions/lib/triage/conversationsCategoriesStoreUpdate';
import { getApplyConversationActionContext, getContextFolderIdForTable, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import * as undoActions from 'owa-mail-undo';
import { handleServiceError } from 'owa-service-error';
import strings from 'owa-strings/owa-mail-strings';
import tombstoneOperations from 'owa-mail-list-tombstone';
/**
 * Categorize the conversations from table
 * @param conversationRowKeys to be categorized
 * @param tableView that contain the conversations
 * @param categorizesToAdd the categories to add to the conversations
 * @param categorizesToRemove the categories to be removed from the conversations
 * @param clearCategories a boolean which indicates whether to clear categories for the specified conversations
 * @param actionSource where the action is triggered from
 * @param promiseToWaitUpon promise to wait upon before sending the update category request.
 */
export default function updateConversationsCategoriesInternal(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource, promiseToWaitUpon) {
    // Validate category parameters and throw error if they are invalid
    validateCategoryParameters(conversationRowKeys, categoriesToAdd, categoriesToRemove, clearCategories);
    undoActions.clearLastUndoableAction();
    if (promiseToWaitUpon) {
        // In case where user creates a category from the commanding bar drop down
        // we want to only send the request to apply the category only if the creation of
        // category succeeds. Today the promiseToWaitUpon here is create Category action
        promiseToWaitUpon.then(function (isPromiseSuccessful) {
            submitRequestAndMakeLocalUpdate(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
        });
    }
    else {
        submitRequestAndMakeLocalUpdate(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
    }
}
function submitRequestAndMakeLocalUpdate(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    // 1. Local update the conversation categories in store
    conversationsCategoriesStoreUpdate(conversationRowKeys, tableView.id, categoriesToAdd, categoriesToRemove, clearCategories);
    // Add category operation to tombstone
    // 2. The local update operation should happen before adding category to tombstone
    // else we may not have correct set of categories when adding it to the tombstone
    addCategoryOperationToTombstone(conversationRowKeys, tableView);
    // 3. submit server request
    submitUpdateConversationsCategories(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
}
function submitUpdateConversationsCategories(conversationRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    handleServiceError('updateConversationsCategoriesInternal', strings.errorUpdatingCategories, function () {
        var contextFolderId = getContextFolderIdForTable(tableView);
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return getApplyConversationActionContext(rowKey, tableView.id);
        });
        var datapoint = returnTopExecutingActionDatapoint();
        var promiseToReturn = updateConversationsCategoriesService(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories).catch(function (e) {
            datapoint.endWithError(DatapointStatus.ServerError);
        });
        return promiseToReturn;
    });
}
function addCategoryOperationToTombstone(conversationRowKeys, tableView) {
    // Add each row to the tombstone map
    conversationRowKeys.forEach(function (conversationRowKey) {
        var conversationCategories = MailRowDataPropertyGetter.getCategories(conversationRowKey, tableView);
        tombstoneOperations.add([conversationRowKey], tableView.serverFolderId, {
            type: 3 /* OnEqualCategories */,
            value: conversationCategories ? conversationCategories : [],
        });
    });
}
//# sourceMappingURL=updateConversationsCategoriesInternal.js.map